import { render } from "./Conversations.vue?vue&type=template&id=bafdfb66"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"
script.render = render

export default script